import { makeStyles } from '@fluentui/react-components';

export const useNoDataStyles = makeStyles({
  noDataContainer: {
    height: '100%',
    flexGrow: 1,
    textAlign: 'center',
    alignContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContainer: {
    justifyItems: 'center',
  },
  text: {
    display: 'block',
    marginTop: '1px',
  },
});

